import React from "react";
import { Card, DataList } from "@chakra-ui/react";
import { Product } from "@/shared/core-products";

interface CardProductDetailsProps {
  title: string;
  product: Product;
}

const CardProductDetails: React.FC<CardProductDetailsProps> = ({
  title,
  product,
}) => {
  const items = [
    {
      label: "Código",
      value: product.externalProduct?.code || product.erpProduct?.erpCode,
    },
    { label: "Descripción", value: product.description },
    { label: "Unidad", value: product.unit },
    { label: "Ubicación", value: product.location },
    { label: "Stock", value: product.stock },
    { label: "Bodega", value: product.storage?.name },
    { label: "Conversión", value: product.converterType?.name },
  ];

  return (
    <Card.Root variant="outline">
      <Card.Header>
        <Card.Title fontSize="md">{title}</Card.Title>
      </Card.Header>
      <Card.Body>
        <DataList.Root orientation="horizontal" size="sm">
          {items.map((item) => (
            <DataList.Item key={item.label}>
              <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
              <DataList.ItemValue>{item.value ?? "—"}</DataList.ItemValue>
            </DataList.Item>
          ))}
        </DataList.Root>
      </Card.Body>
    </Card.Root>
  );
};

export default CardProductDetails;
